import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Card,
    Button,
    Table,
    Radio,
    Dropdown,
    Tag,
    message
} from "antd";
import { EditOutlined, VideoCameraOutlined, LockOutlined } from '@ant-design/icons';

// Constants
import {
    COMMON_FEATURES,
    TEMPLATE
} from '../../../../../../constants'

// columns
// import UserRoleTag from '../../../../../../components/UserRoleTag'
import ModalStandard from '../../../../../../components/ModalStandard';
import SVG from '../../../../../../components/SVG';
import { PrimaryButton } from '../../../../../../components/Decoration/Button';

// Services
import { REDUX, TIME } from '../../../../../../services/util'

// Handler
import { 
    // vehicles_handler,
    table_handler,
    xlsx_handler
} from '../../../../../../handlers'
import { useNavigate } from 'react-router';

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../../services/redux/actions'
import { ModalResetPassword } from '../UserEditForm/resetPassword';
// import { exportReportFile } from '../../../../../../handlers/xlsxHDLR';

const {
    reduxStoreWrapper
} = REDUX

const {
    STATUS_LABEL
} = TEMPLATE.VEHICLE


const { getColumnSearchProps } = table_handler
const { exportReportFile } = xlsx_handler
// const { vehicleECUValidator } = vehicles_handler

const { parseDate } = TIME

const UserInfoPanel = ({uid}) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const users = useSelector(reduxStoreWrapper('userHierarchy.byID'))
    const vehicleGroups = useSelector(reduxStoreWrapper('vehicleGroups'))
    const curUserRole = useSelector(reduxStoreWrapper('user.uroleid'))
    // const _uid = useSelector(reduxStoreWrapper('user.uid'))
    const vehicleStates = useSelector(reduxStoreWrapper('vehicles.stateByID'))
    const vehicleFuelProfiles = useSelector(reduxStoreWrapper('vehicles.fuelProfileByID'))
    const vehiclePackageProfiles = useSelector(reduxStoreWrapper('vehicles.vehiclePKGByID'))
    const vehicleStaticses = useSelector(reduxStoreWrapper('vehicles.staticsByID'))
    // const vehiclePackages = useSelector(reduxStoreWrapper('subscriptionPackages.vehiclePKGByID')) 

    const deviceGroups = useSelector(reduxStoreWrapper('deviceGroups'))
    const deviceStaticses = useSelector(reduxStoreWrapper('devices.staticsByID'))

    const vehiclesByUID = [...new Set(vehicleGroups.vidsByUID[uid])]
        .reduce((acc, vid) => {
            const data = vehicleStaticses[vid];
            if (data) acc.push(data);
            return acc;
        }, []);
    const devicesByUID = [...new Set(deviceGroups.dvidsByUID[uid])]
        .reduce((acc, dvid) => {
            const data = deviceStaticses[dvid];
            if (data) acc.push(data);
            return acc;
        }, []);

    const style = useSelector(reduxStoreWrapper('style'))

    // const [ dataSource, setDataSource ] = useState([])

    const searchTextState = useState('')
    const searchedColumnState = useState('')

    useEffect(() => {
        if(uid) {
            dispatch(REDUX_ACTIONS.v3_userHierarchy.hierarchial_user_info_get_request(uid))
        }
    }, [uid])

    const [ openResetPwd, setOpenResetPwd ] = useState(false)

    const rows = [
        [
          {
            title: "Name",
            value: (uid && users && users[uid] && users[uid].name) || ''
          },
          {
            title: "Email",
            value: (uid && users && users[uid] && users[uid].email) || ''
          }
        ],
        [
            {
              title: "Address",
              value: (uid && users && users[uid] && users[uid].address) || ''
            },
          {
            title: "Password",
            value: "***"
          }
        ],
        [
        {
            title: "Contact",
            value: (uid && users && users[uid] && users[uid].contact) || ''
          },
          {
            title: "Reset Password",
            value: 
            <>
                {
                    openResetPwd && users[uid]
                    &&
                    <ModalResetPassword 
                        data={{ name: users[uid]?.name || '', uid: uid || '', email: users[uid]?.email || '' }} 
                        open={openResetPwd}
                        onCancel={() => setOpenResetPwd(false)}
                    />
                }
                <Button icon={<LockOutlined />} danger onClick={() => setOpenResetPwd(true)}>Reset Password</Button>
            </>
          }
        //   {
        //     title: "Role",
        //     value: users && users[uid] && <UserRoleTag uroleid={users[uid].uroleid}/>
        //   }
        ]
    ]

    const devicePanelColumns = (exportState) => [
        {
          title: "Device IMEI",
          dataIndex: "imei",
          fixed: 'left',
          width: 160,
          ...getColumnSearchProps("Device IMEI", 'imei', searchTextState, searchedColumnState),
          render: data => data
        },
        {
          title: "Vehicle Plate",
          dataIndex: "plate",
          ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
          render: data => data
        },
        {
            title: "Device SIM",
            dataIndex: "simContact",
            width: 180,
            ...getColumnSearchProps("Device SIM", 'sim', searchTextState, searchedColumnState),
            render: data => data
          },
        {
            title: "Phone Number",
            dataIndex: "contact",
            ...getColumnSearchProps("Phone Number", 'contact', searchTextState, searchedColumnState),
          },
          {
            title: "Company",
            dataIndex: "company",
            ...getColumnSearchProps("Company", 'company', searchTextState, searchedColumnState),
            render: data => users[data]?.name
          },
          {
            title: "Model",
            dataIndex: "model",
            ...getColumnSearchProps("Model", "model", searchTextState, searchedColumnState),
            render: data => data
          },
        {
          title: "Status",
          dataIndex: "status",
            filters: Object.values(STATUS_LABEL).map(sl => ({
                text: <Tag color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                value: sl.status
            })),
            onFilter: (value, record) => record.status === Number(value),
            render: (data) => 
                exportState ?
                STATUS_LABEL[data]?.label
            :
                <Tag color={STATUS_LABEL[data]?.color}>
                    {STATUS_LABEL[data]?.label}
                </Tag>,
        },
          {
            title: "Last Updated By",
            defaultSortOrder: "descend",
            width: 190,
            sorter: (a, b) => a.updatedAt - b.updatedAt,
            render: (data) => {
                const name = users[data.updatedBy]?.name || '-'

                return exportState ?
                `${name}/ ${parseDate(Number(data.updatedAt))}`
                :
                 (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.updatedAt))}</>
                    </>
                )
            }
          },
        {
            title: "Created By",
            width: 190,
            sorter: (a, b) => a.createdAt - b.createdAt,
            render: (data) => {
                const name = users[data.createdBy]?.name || '-'

                return exportState ? 
                `${name}/ ${parseDate(Number(data.createdAt))}`
                :
                (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.createdAt))}</>
                    </>
                )
            }
          },
        {
            title: "Actions",
            fixed: 'right',
            render: data => {

                const dataItems = {
                    dvid: data.dvid,
                    simContact: data.simContact,
                    company: data.company,
                    uid,
                }

                const items = [
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => navigate(`/update/device`, {state: { data: { ...data, title: 'Edit' } }})}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_devices.update_device_request({
                                    ...dataItems,
                                    status: 1,
                                },
                                () => {},
                                () => message.error('Failed in Mark the device as Inactive. Retry?')
                            ))}}
                            disabled={data.status === 1}
                            title={'Mark as active'}
                            content={'You are about to mark this device as active.'}
                            subcontent={`${data.imei || '-'}`}
                            // icon={<></>}
                        >
                            Mark as active
                        </ModalStandard>
                    },
                    {
                        key: '3',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_devices.update_device_request({
                                    ...dataItems,
                                    status: 0,
                                },
                                () => {},
                                () => message.error('Failed in Mark as Inactive. Retry?')
                            ))}}
                            disabled={data.status === 0}
                            title={'Mark as inactive'}
                            content={'You are about to mark this device as inactive.'}
                            subcontent={`${data.imei || '-'}`}
                            // icon={<></>}
                        >
                            Mark as inactive
                        </ModalStandard>
                    }
                ]

                return (
                    <Dropdown menu={{ items }}>
                        <EditOutlined />
                    </Dropdown>
                )

            }
          }
      ];

      const vehiclePanelColumn = (exportState) => [
        {
          title: "Vehicle Plate",
          dataIndex: "plate",
          fixed: 'left',
          width: 150,
          ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
          render: data => exportState ? data || '-' : data || '-'
        },
        {
          title: "Status",
          dataIndex: "status",
          width: 150,
            filters: Object.values(STATUS_LABEL).map((sl, i) => ({
                text: <Tag key={i} color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                value: sl.status
            })),
            onFilter: (value, record) => record.status === Number(value),
            render: (data) => 
                exportState ?
                    STATUS_LABEL[data]?.label || '-'
                :
                    <Tag color={STATUS_LABEL[data]?.color}>
                        {/* <Badge color={STATUS_LABEL[data]?.color} style={{ marginRight: '8px'}}/> */}
                        {STATUS_LABEL[data]?.label}
                    </Tag>,
        },
        {
            title: "Devices",
            width: 160,
            ...getColumnSearchProps("Status", 'status', searchTextState, searchedColumnState),
            render: ({ gnss_status = 0, fuel_sensor = 0, mdvr = 0 }) => {

                const color = (status) => status === 1 ? 'green' : '#C8C8C8'

                return exportState ?
                `${gnss_status && 'GPS' || '-'} ${fuel_sensor && ', Fuel' || '-'}${(!gnss_status && !fuel_sensor) && 'No' || ''} Sensor`
                : 
                (
                    <div >
                        <SVG fill={color(gnss_status)} name='gps_sensor' size='2.5em'/>
                        <SVG fill={color(fuel_sensor)} name='fuel_sensor' size='2.5em'/>
                        <VideoCameraOutlined style={{ color: color(mdvr), fontSize: '1.5em',  position: 'absolute' }}/>
                    </div>
                )
            }

          },
        {
          title: "Vehicle Groups",
          dataIndex: "vhcgids",
          width: 250,
          render: (vhcgids) => 
            exportState ?
            `${vhcgids?.map(vhcgid => vehicleGroups.byID[vhcgid].name)?.join(', ')}`
            :
            (
              <>
                {
                    vhcgids.map((vhcgid, i) => (
                        <Tag key={i} color={vehicleGroups.byID[vhcgid]?.color !== '#FFFFFF' ? vehicleGroups.byID[vhcgid]?.color : "blue"}>
                            {vehicleGroups.byID[vhcgid].name}
                        </Tag>
                    ))
                }
              </>
          )
        },
        // {
        //   title: "Vehicle Name",
        //   dataIndex: "displayName",
        //   width: 150,
        //   ...getColumnSearchProps("Vehicle Name", 'displayName', searchTextState, searchedColumnState),
        //   render: data => data
        // },
        {
          title: "Company",
          dataIndex: "company",
          width: 170,
          ...getColumnSearchProps("Company", 'company', searchTextState, searchedColumnState),
          render: data => users[data]?.name
        },
        {
          title: "Type",
          dataIndex: "type",
          ...getColumnSearchProps("Type", "type", searchTextState, searchedColumnState),
          render: data => data
        },
        {
          title: "Model",
          dataIndex: "model",
          ...getColumnSearchProps("Model", "model", searchTextState, searchedColumnState),
          render: data => data
        },
        {
          title: "Assigned GPS",
          dataIndex: "dvid",
          isHidden: TEMPLATE.USER_ROLE.FILTER_OUT_ROLE.includes(curUserRole), //this column will be filtered out if user is fleetOwner
          ...getColumnSearchProps("Assigned Device", 'dvid', searchTextState, searchedColumnState),
          render: data => data?.split('#')[1] || '-'
        },
        {
          title: "Assigned MDVR",
          dataIndex: "mdvrid",
          isHidden: TEMPLATE.USER_ROLE.FILTER_OUT_ROLE.includes(curUserRole), //this column will be filtered out if user is fleetOwner
          ...getColumnSearchProps("Assigned MDVR", 'mdvrid', searchTextState, searchedColumnState),
        //   render: data => data?.split('#')[1] || '-'
        },
        // {
        //     title: "Vehicle Package",
        //     // dataIndex: "vehiclePackage",
        //     dataIndex: "vpkgids",
        //     width: 250,
        //     // render: vehiclePackage => <VehiclePackageLabel vehiclePackage={vehiclePackage}/>
        //     render: data => 
        //         data
        //         &&
        //         Array.isArray(data)
        //         &&
        //         (exportState ?
        //         data.map(vpkgid => vpkgid !== 'All' ? vehiclePackages[vpkgid]?.name : 'All')?.join(', ')
        //         :
        //         (
        //             data?.map((vpkgid, i) => 
        //                 <Tag key={i} color={'blue'}>
        //                     {vpkgid !== 'All' ? vehiclePackages[vpkgid]?.name : 'All'}
        //                 </Tag>
        //             )
        //         ))
        // },
        // {
        //     title: "Vehicle Package Status",
        //     dataIndex: "vehiclePackage",
        //     filters: Object.keys(TEMPLATE.PACKAGE.VEHICLE_PACKAGE_STATUS_CODE).map(code=> (
        //       {
        //           text: TEMPLATE.PACKAGE.VEHICLE_PACKAGE_STATUS_CODE[code],
        //           value: code,
        //       }
        //     )),
        //     onFilter: (value, record) => record.vehiclePackage && Number(record.vehiclePackage.status) === Number(value),
        //     render: vehiclePackage => <VehiclePackageStatus vehiclePackage={vehiclePackage}/>
        // },
        {
            title: "Registration Date",
            dataIndex: "registeredAt",
            // defaultSortOrder: "ascend",
            width: 180,
            sorter: (a, b) => a.registeredAt - b.registeredAt,
            render: registeredAt => parseDate(Number(registeredAt)),
          },
          {
            title: "Last Updated By",
            defaultSortOrder: "descend",
            // dataIndex: 'updatedAt',
            width: 190,
            sorter: (a, b) => a.updatedAt - b.updatedAt,
            render: (data) => {
                const name = users[data.updatedBy]?.name || '-'

                return exportState ?
                    `${name}/ ${parseDate(Number(data.updatedAt))}`
                :
                (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.updatedAt))}</>
                    </>
                )
            }
          },
        {
            title: "Created By",
            width: 190,
            // dataIndex: 'createdAt',
            sorter: (a, b) => a.createdAt - b.createdAt,
            render: (data) => {
                const name = users[data.createdBy]?.name || '-'

                return exportState ?
                    `${name}/ ${parseDate(Number(data.createdAt))}`
                :
                (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.createdAt))}</>
                    </>
                )
            }
          },
        {
            title: "Actions",
            fixed: 'right',
            render: data => {

                const newData = {
                    vehicle: {
                        vid: data.vid,
                        status: data.status,
                        plate: data.plate,
                        displayName: data.displayName,
                        brand: 'teltonika',
                        model: data.model,
                        type: data.type,
                        registeredAt: data.registeredAt,
                        chassisNumber: data.chassisNumber,
                        engineNumber: data.engineNumber,
                        fuel_type: data.fuel_type,
                        loadedWeight: data.loadedWeight,
                        unloadedWeight: data.unloadedWeight,
                        engineCC: data.engineCC || 0,
                    },
                    ...data.fuelProfile && {fuelProfile: {
                        tankNum: data.fuelProfile?.length || 1,
                        // '0_model': data.model,
                        ...data.fuelProfile
                    }},
                    imei: data.imei || data?.dvid?.split('#')[1] || '',
                    vhcgids: data.vhcgids,
                    vpkgids: data.vpkgids,
                    company: data.company,
                    uid: uid
                }

                const items = [
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => navigate(`/update/vehicle`, {state: { data: { ...data, title: 'Edit' } }})}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicles.update_vehicle_request({
                                    ...newData,
                                    vehicle: {
                                        ...newData.vehicle,
                                        status: 1
                                    },
                                    uid: uid
                                }))
                            }}
                            disabled={data.status === 1}
                            title={'Mark as active'}
                            content={'You are about to mark this vehicle as active.'}
                            subcontent={`${data.displayName || '-'}`}
                            // icon={<></>}
                        >
                            Mark as active
                        </ModalStandard>
                    },
                    {
                        key: '3',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicles.update_vehicle_request({
                                    ...newData,
                                    vehicle: {
                                        ...newData.vehicle,
                                        status: 0
                                    },
                                    uid: uid
                                }))
                            }}
                            disabled={data.status === 0}
                            title={'Mark as inactive'}
                            content={'You are about to mark this vehicle as inactive.'}
                            subcontent={`${data.displayName || '-'}`}
                            // icon={<></>}
                        >
                            Mark as inactive
                        </ModalStandard>
                    }
                ]

                return (
                    <Dropdown menu={{ items }}>
                        <EditOutlined />
                    </Dropdown>
                )

            }
          }
      ];

    // const isInit = useRef(false)

    // useEffect(() => {
    //     if(isInit.current) {
    //         dispatch(REDUX_ACTIONS.v3_user.get_vehicle_by_uid_request(uid))
    //     }
    //     isInit.current = true
    // }, [uid])

    const [tab, setTab] = useState(COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT)

    const PANELS = {
        [COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT]: {
            label: 'Vehicles',
            column: vehiclePanelColumn(),
        },
        [COMMON_FEATURES.FEATURE_NAME.DEVICE_MANAGEMENT]: {
            label: 'Devices',
            column: devicePanelColumns(),
        },
    }

    const preDataSource = {
        [COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT]:
            vehiclesByUID.sort((b, a) => b.plate - a.plate)
                .map((vehicleStatics) => {

                    const vid = vehicleStatics.vid
                    const vehiclePackage = vehiclePackageProfiles[vid]
                    const vehicleFuelProfile = vehicleFuelProfiles[vid]
                    const vehicleState = vehicleStates[vid]
            
                    const vhcgids = vehicleGroups.allIDs.filter(vhcgid => vehicleGroups.byID[vhcgid].vehicles && vehicleGroups.byID[vhcgid].vehicles.includes(vid))
            
                    return {
                        key: vid,
                        vhcgids,
                        company: '-',
                        vpkgids: vehiclePackage?.vpkgids || [],
                        ...vehicleStatics,
                        ...vehicleState,
                        fuelProfile: vehicleFuelProfile,
                        fuel_sensor: vehicleFuelProfile ? 1 : 0,
                        status: vehicleStatics.status || 0,
                        registeredAt: vehicleStatics.registeredAt || vehicleStatics.createdAt,
                        mdvr: (vehicleStatics.mdvrid) && (vehicleStatics.mdvrid !== '') && (vehicleStatics.mdvrid !== '-') ? 1 : 0
                    }
                }),
        [COMMON_FEATURES.FEATURE_NAME.DEVICE_MANAGEMENT]:
            devicesByUID.sort((b, a) => b.plate - a.plate)
            .map(deviceStatics => {
                const dvid = deviceStatics.dvid

                const vehicle = Object.values(vehicleStaticses).find(v => v.dvid === dvid)
                const company = users[deviceStatics.company]?.name || '-'
                const contact = users[deviceStatics.company]?.contact || '-'

                return {
                    key: dvid,
                    imei: dvid?.split('#')[1],
                    plate: vehicle?.plate || '-',
                    company: company || '-',
                    contact: contact || '-',
                    status: deviceStatics.status || 0,
                    ...deviceStatics,
                }
            })
            
            
    }

    const dataSource = preDataSource[tab] || []

    return (
        <>
            <Card
                title = {
                    <span
                        style = {{
                            display: "inline-table",
                            width: "100%",
                            height: "56px",

                            position: "absolute",
                            top: 0,
                            left: 0,

                            color: style.textColor,
                            backgroundColor: style.pageHeaderColor,
                        }}
                    >
                    <p
                        style = {{
                        fontWeight: "bold",
                        fontSize: "24px",
                        margin: "10px"
                        }}
                    >
                        {uid && users && users[uid] && users[uid].name || "User Name"}
                    </p>
                    </span>
                }
                style = {{
                    margin: "5% 10%"
                }}
            >
                <div style = {{ padding: "10px 15px 10px 15px" }}>
                    {
                    rows.map(row => (
                        <div
                        key = {row[0].title}
                        style = {{
                            display: "flex",
                            flexDirection: "row",
                            margin: "20px"
                        }}
                        >
                        <div style = {{ width: "15%", fontWeight: "bold" }}>
                            {row[0].title}
                        </div>

                        <div style = {{ width: "30%", paddingLeft: "5px" }}>
                            {row[0].value}
                        </div>

                        <div style = {{ width: "10%" }} />

                        <div style = {{ width: "15%", fontWeight: "bold" }}>
                            {row[1].title}
                        </div>

                        <div style = {{ width: "30%", paddingLeft: "5px" }}>
                            {row[1].value}
                        </div>
                        </div>
                    ))
                    }
                </div>
            </Card>



            <div style={{ margin: '0 10%' }}>
                <div style={{ display: 'flex', gap: '7px', float: 'right', marginBottom: '15px'}}>
                    <PrimaryButton style={{ float: 'right', marginBottom: '15px' }} icon={<EditOutlined />} onClick={() => navigate(`/update/user`, { state: { data: { ...users[uid], vhcgids: vehicleGroups.relationByUID[uid]} }})} >
                        Edit user
                    </PrimaryButton>
                    { 
                        users[uid]?.uroleid === 'D'
                        &&
                        <PrimaryButton style={{ float: 'right', marginBottom: '15px' }} onClick={() => tab === COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT ? navigate (`/create/vehicle`, { state: { data: {route: '/management/user'} }}) : navigate (`/create/device`, { state: { data: { prevPathname: '/management/gps' } }})}>
                            + Add {tab === COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT ? 'Vehicle' : 'Device'}
                        </PrimaryButton>
                    }
                    <PrimaryButton
                        onClick={() => {
                            const col = tab === COMMON_FEATURES.FEATURE_NAME.VEHICLE_MANAGEMENT ? vehiclePanelColumn(true) : devicePanelColumns(true)

                            exportReportFile(dataSource, col, "Main", `${users[uid]?.name || ''}_${tab}`)
                        }}
                        disabled={!dataSource.length}
                    >
                        Export
                    </PrimaryButton>
                </div>
                <Radio.Group value={tab} buttonStyle="solid" onChange={e => setTab(e.target.value)}>
                    {
                        Object.keys(PANELS)
                            .map(panel =>
                                <Radio.Button key={panel} value={panel}>
                                    {PANELS[panel]?.label}
                                    {/* test */}
                                </Radio.Button>
                            )
                    }
                </Radio.Group>

                <Table 
                    dataSource={dataSource}
                    columns={PANELS[tab]?.column}
                    scroll={{
                        y: window.innerHeight / 2,
                        x: PANELS[tab]?.column && PANELS[tab]?.column?.length * 180
                    }}
                />
            </div>

        </>
    )
}

export default React.memo(UserInfoPanel)